import { useField, useFormikContext } from "formik"
import React, { useEffect, useState } from "react"
import { ActionMeta, ValueType } from "react-select"
import { useTranslation } from "react-i18next"
import { PaginationSelectBase, PaginationSelectBaseProps } from "../PaginationSelectBase/PaginationSelectBase"

export interface PaginationSelectFormProps extends Omit<PaginationSelectBaseProps, "onChange"> {
    name: string
    getInitialLabel: (value: string) => Promise<string>
}

export const FormPaginationSelect = (props: PaginationSelectFormProps) => {
    const { name, getOptions, getInitialLabel, dataTestId, ...restProps } = props
    const { setFieldValue } = useFormikContext()
    const [field, meta] = useField(name)
    const [label, setLabel] = useState("")

    // Загрузка начального заголовка, если в поле формы было заполнено значение
    useEffect(() => {
        if (field.value) {
            getInitialLabel(field.value).then(label => {
                setLabel(label)
            })
        }
    }, [])

    const handleChange = (
        option: ValueType<{ label: string; value: string }, false>,
        actionMeta: ActionMeta<{ label: string; value: string }>
    ) => {
        if (actionMeta.action === "select-option" && option) {
            setFieldValue(name, option.value)
            setLabel(option.label)
        }
    }
    const { t } = useTranslation()

    const errorText = meta.error && meta.touched ? t(meta.error) : undefined

    return (
        <PaginationSelectBase
            value={{ value: field.value, label: label }}
            getOptions={getOptions}
            onChange={handleChange}
            errorText={errorText}
            dataTestId={dataTestId}
            {...restProps}
        />
    )
}
